import { ComponentDocs } from "components/docs";

const NavigationLogger = () => (
  <ComponentDocs
    name="<NavigationLogger/>"
    entry="NavigationLogger"
    propsEntry="NavigationLoggerProps"
  />
);

export default NavigationLogger;
